<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">แบบฟอร์มคำร้องขอใช้พื้นที่ จาก RSP</div>
        <div class="d-flex align-center">
          <Iconify
            icon="bxs:message-square-detail"
            color="var(--theme-color-seven)"
            class="mr-3"
          ></Iconify>
          <div class="">แบบฟอร์มคำร้องขอใช้พื้นที่ จาก RSP</div>
        </div>
      </div>
      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center gap-8" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
              placeholder="สถานะ"
              hide-details
              clearable
              :items="statusMaster"
              item-text="label"
              item-value="value"
              @onChange="
                searchData.status = $event;
                getLists();
              "
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
              @onChange="searchData.keyword = $event"
              @onEnter="getLists()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-space-between mb-5 px-8">
      <div v-for="(item, i) in headers" :key="i" :style="{ width: item.width }">
        {{ item.name }}
      </div>
    </div>
    <div class="list-layout">
      <div v-for="(item, i) in reqList" :key="i">
        <RowCard>
          <div :style="{ color: getColorVariable(), width: headers[0].width }">
            {{ item?.No }}
          </div>
          <div :style="{ width: headers[1].width }">
            {{ item?.fiscal_year }}
          </div>
          <div :style="{ width: headers[2].width }">อุทยานวิทยาศาสตร์</div>
          <div :style="{ width: headers[3].width }">
            {{ item?.region }}
          </div>
          <div :style="{ width: headers[4].width }">
            ครั้งที่ {{ item?.running_number }}
          </div>
          <div
            :style="{
              width: headers[5].width,
              color: getColorStatus(checkGroupStatus(item?.area_forms)),
            }"
          >
            {{checkGroupStatus(item?.area_forms)}}
          </div>
          <v-btn
            icon
            :class="{ rotate180: isExpanded[i] }"
            @click="() => seeDetail(i)"
          >
            <Iconify
              icon="material-symbols:keyboard-arrow-down"
              size="32px"
              :color="getColorVariable()"
            ></Iconify>
          </v-btn>
        </RowCard>
        <div class="expand-layout px-5" :class="`expand-${i}`">
          <div class="expand-content d-flex flex-column gap-12">
            <div
              class="d-flex text-left items-center justify-space-between table-head"
            >
              <div
                v-for="(item, i) in subHeaders"
                :key="i"
                :style="{ width: item.width, color: '#B1B1B1', textAlign:(i === 4 || i === 2 || i === 3) ? 'center' : '' }"
              >
                {{ item.name }}
              </div>
            </div>
            <div v-if="item?.area_forms.length > 0">
              <div
                v-for="(area, i) in item?.area_forms"
                :key="area.id || i"
                class="d-flex px-9 gap-8 text-left items-center justify-space-between"
                style='padding-top: 11px'
              >
                <div div :style="{ width: subHeaders[0]?.width }">
                  <v-btn
                    v-if="area?.spider_form !== null"
                    small
                    icon
                    class="edit-icon-class"
                    @click="
                      onPreview(
                        area?.spider_form?.id
                      )
                    "
                  >
                    <Iconify
                      icon="material-symbols:visibility"
                      color="var(--theme-color-seven)"
                      size="18px"
                    ></Iconify>
                  </v-btn>
                </div>
                <div :style="{ width: subHeaders[1].width }">
                  {{ area?.area_form_2?.company_name_th }}
                </div>
                <div :style="{ width: subHeaders[2].width, display: 'flex', justifyContent: 'center' }">
                  {{ dateFormatting(area?.approved_at) }}
                </div>
                <div :style="{ width: subHeaders[3].width, display: 'flex', justifyContent: 'center' }">
                  {{ dateFormatting(area?.exit_at) }}
                </div>
                <div  :style="{ width: subHeaders[4].width, display: 'flex', gap:'12px',justifyContent: 'center' }">
                  <div :style="{  display: 'flex', gap:'12px',justifyContent: 'center' }" v-if="area?.spider_form?.status === 'Submitted'">
                    <Button
                        @onClick="changeStatus(area?.spider_form?.id,'Not Approved')"
                        minWidth="130px"
                        theme="2"
                        style="translate: 0px -10px"
                      >
                        <span>Not Approve</span>
                      </Button>
                      <Button
                        @onClick="changeStatus(area?.spider_form?.id,'Approved')"
                        minWidth="130px"
                        theme="1"
                        style="translate: 0px -10px"
                      >
                        <span>Approve</span>
                      </Button>
                  </div>
                  <div v-else :style="{ color: getColorStatus(area?.spider_form?.status) }" >
                  {{ area?.spider_form?.status }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="flex text-center">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>
    </div>
    <v-pagination
      class="mt-6"
      v-model="paginate.current_page"
      :length="paginate.last_page"
      color="#DE7033"
      @input="getLists"
    ></v-pagination>
  </div>
</template>

<script>
import RowCard from "@/components/RowCard";
import SelectBox from "@/components/input/SelectBox";
import TextField from "@/components/input/TextField";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import Button from "@/components/input/Button";

export default {
  name: "spaceRequestsRSP",
  components: {
    RowCard,
    SelectBox,
    TextField,
    Button,
  },
  data() {
    return {
      toDateFormat,
      formatNumber,
      redText: false,
      isExpanded: [],
      statusMaster: [
        { label: "รออนุมัติ", value: "Submitted" },
        { label: "อนุมัติ", value: "Approved" },
      ],
      searchData: {
        status: null,
        keyword: null,
      },
      headers: [
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "ปี งปม.",
          width: "8%",
        },
        {
          name: "ชื่อโครงการหลัก",
          width: "34%",
        },
        {
          name: "ภูมิภาค",
          width: "12%",
        },
        {
          name: "ครั้งที่",
          width: "12%",
        },
        {
          name: "สถานะ",
          width: "26%",
        },
        {
          name: "",
          width: "2%",
        },
      ],
      subHeaders: [
        {
          name: "Action",
          width: "8%",
        },

        {
          name: "บริษัท",
          width: "32%",
        },
        {
          name: "วันที่อนุมัติ",
          width: "18%",
        },
        {
          name: "วันที่ออก",
          width: "18%",
        },
        {
          name: "สถานะ",
          width: "24%",
        },
      ],
      reqList: [
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    seeDetail(index) {
      let growDiv = document.querySelector(`.expand-${index}`);
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.$set(this.isExpanded, index, false);
      } else {
        let wrapper = growDiv.querySelector(".expand-content");
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.$set(this.isExpanded, index, true);
      }
    },
    getColorVariable() {
      return "var(--theme-color-one)";
    },
    getColorStatus(status) {
      if (status == "Submitted") {
        return "var(--theme-color-five)";
      } else if (status == "Draft") {
        return "var(--theme-color-seven)";
      } else if (status == "Not Approved") {
        return "var(--theme-color-four)";
      } else if (status == "Approved") {
        return "var(--theme-color-three)";
      } else if (status == "In Review") {
        return "var(--theme-color-one)";
      }
    },
    checkStatus(data) {
      if (data?.area_forms.length === 0) return false;
      console.log("checkStatus data: ", data);
      const status = data?.area_forms.every(
        (item) => item?.evaluate_forms?.status === "Submitted"
      );
      return status;
    },
    checkGroupStatus(data) {
      if (data.length === 0) return '';
      const status = data?.every(
        (item) => item?.spider_form?.status === "Approved" || item?.spider_form?.status === "Not Approved"
      );
      return status === true ? "Approved" : "Submitted";
    },
    async getLists(page) {
      let payload = {
        page: page,
        status: this.searchData.status ?? "Submitted,Approved",
        keyword: this.searchData.keyword,
      };
      let res = await this.$apiFire("Request/getEvaluateAreaList", payload);
      if (res) {
        console.log("res: ", res);
        this.reqList = res?.data.map((item, index) => {
          return {
            ...item,
            No: (res.current_page - 1) * res.per_page + index + 1,
          };
        });
        this.paginate = {
          total: res.total,
          per_page: res.per_page,
          current_page: res.current_page,
          last_page: res.last_page,
        };
      }
    },
    async changeStatus(id,status) {
      const payload = {
        id: id,
        status: status
      }
        let res = await this.$apiFire("Request/changeStatusSpiderChart", payload);
        if (res) {
          this.getLists();
      }
    },
    onEdit(id) {
        this.$router.push({
          name: "spiderChartFormEdit",
          params: {
            id: id,
          },
        });
    },
    onPreview(id) {
      this.$router.push({
          name: "spiderChartPreview",
          params: {
            id: id,
            preview: true
          },
        });
    },
    dateFormatting(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);

      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      const thaiLocaleDate = new Intl.DateTimeFormat("th-TH", options).format(
        date
      );

      const thaiMonthAbbreviations = {
        มกราคม: "ม.ค.",
        กุมภาพันธ์: "ก.พ.",
        มีนาคม: "มี.ค.",
        เมษายน: "เม.ย.",
        พฤษภาคม: "พ.ค.",
        มิถุนายน: "มิ.ย.",
        กรกฎาคม: "ก.ค.",
        สิงหาคม: "ส.ค.",
        กันยายน: "ก.ย.",
        ตุลาคม: "ต.ค.",
        พฤศจิกายน: "พ.ย.",
        ธันวาคม: "ธ.ค.",
      };
      const [day, month, yearTime] = thaiLocaleDate.split(" ");

      const abbreviatedMonth = thaiMonthAbbreviations[month] || month;

      const year = parseInt(yearTime, 10);

      const time = thaiLocaleDate.split(" ")[4];
      const hour = time.split(":")[0];
      const minute = time.split(":")[1];

      return `${day} ${abbreviatedMonth} ${year} เวลา ${hour}:${minute} น.`;
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 8px 33px 8px 36px;
  margin-bottom: 12px;
  border-bottom: solid 1px var(--theme-color-nine);
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.edit-icon-class {
  translate: 0 -5px;
}
</style>
